import React from 'react'
import styled from 'styled-components'
import { SeverityLevel } from '@microsoft/applicationinsights-web'

import NextDeparture from '../NextDeparture/NextDeparture'
import DepartureCount from '../DepartureCount/DepartureCount'
import { logTrace } from '../../Global/App/ApplicationInsights'

const ShiftDay: React.FC<{
    nowDeparture: any
    nextDeparture: any
}> = ({ nowDeparture, nextDeparture }) => {
    if (!nowDeparture || !nextDeparture) {
        logTrace('nowDeparture or nextDeparture not defined in ShiftDay component', SeverityLevel.Warning)
        return null // TODO: Return error page?
    }

    return (
        <Container>
            <DepartureCount count={nowDeparture.timeLeft} position={1} isLast={true} />
            <NextDeparture
                departureTime={nextDeparture.departureTime}
                departureDay={nextDeparture.departureDayOfWeek}
                next="Next up"
                half={true}
            />
        </Container>
    )
}

export default ShiftDay

const Container = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;

    @media (orientation: landscape) {
        margin-left: 10vw;
    }

    @media (orientation: portrait) {
        margin-top: 10vh;
    }
`
